import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNote = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .5,
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.7832 2.78711C4.54056 2.78711 3.5332 3.79447 3.5332 5.03711V20.0371C3.5332 21.2798 4.54056 22.2871 5.7832 22.2871H19.2832C20.5258 22.2871 21.5332 21.2797 21.5332 20.0371V5.03711C21.5332 3.79447 20.5258 2.78711 19.2832 2.78711H5.7832ZM20.0332 4.28711H5.0332V20.7871H20.0332V4.28711Z",
				fill: "#360802"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.2832 14.4873H17.5832V16.0373H8.2832V14.4873Z",
				fill: "#360802"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.2832 10.6123H12.9332V12.1623H8.2832V10.6123Z",
				fill: "#360802"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.2832 1.3125L8.2832 5.9625L6.7332 5.9625L6.7332 1.3125L8.2832 1.3125Z",
				fill: "#360802"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13.707 1.3125L13.707 5.9625L12.157 5.9625L12.157 1.3125L13.707 1.3125Z",
				fill: "#360802"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M19.1328 1.3125L19.1328 5.9625L17.5828 5.9625L17.5828 1.3125L19.1328 1.3125Z",
				fill: "#360802"
			})
		]
	})
});
export default SvgNote;
